import { useEffect, useState } from 'react';
import { getIngredientTypes } from 'business/services/IngredientService';

const useIngredientTypeList = (showIngredientTypeModal, refetchCounter) => {
  const [ingredientTypeList, setIngredientTypeList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const ingredientTypeList = await getIngredientTypes();
      setIngredientTypeList(ingredientTypeList);
    };
    if (showIngredientTypeModal) {
      fetchData();
    }
  }, [showIngredientTypeModal, refetchCounter]);

  return ingredientTypeList;
};

export default useIngredientTypeList;
